var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateModalApps',{attrs:{"isVisible":_vm.isVisible},on:{"closeM":_vm.closeM}},[_c('ShowAppsModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }